import { Box } from "@mui/material";
import Meetings from "@/modules/meetings/components/meetings/meetings";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

export default function MeetingsModal() {
  const screen = useScreenSize();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: screen.isMobile ? "auto" : "100%",
      }}
    >
      {/* Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Meetings />
      </Box>
    </Box>
  );
}
